(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(24315);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67055:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/bg.ffdbd808.png","height":827,"width":1135,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAyElEQVR42mNof/yIkQEIFj57Y9V082lI+e3HIgyTfrMzIINNM/rlSi69WZh74MP/kqNvXvnufeEIEv/1/z8HAwismN3hO2nGgpKpC9aeKNt593b9gVs55TOPqu3+/5+FoWTabc683W+0V547t+vA1s7/Sw6feR6352XunCUrTBhAwOLsPaHAxQ89uq68fzn57Z//K0+e+D9l/oqJyZsfG3Vt+cjKwPDnLnNC5x31xF0PMyc//bRu2c2HVf8ZGFgY/v9nu/7gDQcALudlICiXaCMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 24315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 23 modules
var esm = __webpack_require__(28677);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js + 17 modules
var mobxreact_esm = __webpack_require__(50828);
// EXTERNAL MODULE: ./src/layout/MainLayout.js + 36 modules
var MainLayout = __webpack_require__(81842);
// EXTERNAL MODULE: ./src/utils/api/sessionPass.js
var sessionPass = __webpack_require__(55275);
// EXTERNAL MODULE: ./src/components/pages/home/index.js + 12 modules
var home = __webpack_require__(91650);
// EXTERNAL MODULE: ./src/utils/store/index.js + 10 modules
var store = __webpack_require__(26721);
// EXTERNAL MODULE: ./src/utils/hooks/useH5StringBuilder.js
var useH5StringBuilder = __webpack_require__(82807);
// EXTERNAL MODULE: ./src/utils/functions/common.js
var common = __webpack_require__(18942);
// EXTERNAL MODULE: ./src/layout/header/icons/Bitop.js
var Bitop = __webpack_require__(40822);
;// CONCATENATED MODULE: ./src/components/pages/home/imgs/bgColor.png
/* harmony default export */ var bgColor = ({"src":"/_next/static/media/bgColor.8d23b8c6.png","height":4929,"width":1512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAICAYAAADTLS5CAAAAP0lEQVR4nB3KIRaAMBAD0QQMLTwMAkrvf0QEarpb918mLrXB1eV6dvR/gaOhZUu8yGtgf0BK3DBTLrZc4uyIA2HGEaTyIvsCAAAAAElFTkSuQmCC","blurWidth":2,"blurHeight":8});
// EXTERNAL MODULE: ./src/components/pages/home/imgs/bg.png
var bg = __webpack_require__(67055);
;// CONCATENATED MODULE: ./src/components/pages/home/imgs/tradingInfoImage.png
/* harmony default export */ var tradingInfoImage = ({"src":"/_next/static/media/tradingInfoImage.6e6e6e47.png","height":1066,"width":766,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAsElEQVR42h3I3W7BYADH4f9ia2w9WGPMtqL1tZV29UbeFw1CIgSJK3D/99Czn3DyHDyqBVH50+xjXUGWW6QqLxW/1CiZYe2G1XrDsBsjvePVh0jSnUfo74j+L6g1R2Gy5Cs/UMtP1NMdQSMmbHXRKJ0S9cZ8N0PidptONMAYh/LJBOcKvNdP9BSg5waqdpBZnJkXW9LM4FV8xmbFwB7Rcn8t+79TfP8D6Y0kc/TSorwBO3FCJxqvf+QAAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/pages/home/imgs/security.png
/* harmony default export */ var security = ({"src":"/_next/static/media/security.eac6e343.png","height":101,"width":82,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAh0lEQVR42iWOPQ7CMBSDvcMpYIQNqRsghFQGCgXxJ4Q6AQNTcs30OskB+KwOX+zY70VRSXGcU1zCHpoy+JE4XrDOKbzRDlZWETygLilUsMh9qODp4pv7eIMjkyd0R/Zx4fWWoEa38HMmzJnVTQH0QnjlAwdxmTLdUtyh85OUExdm5gAa/FyS/iU4cxdQau76AAAAAElFTkSuQmCC","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/pages/home/imgs/protection.png
/* harmony default export */ var protection = ({"src":"/_next/static/media/protection.61daa5a8.png","height":101,"width":110,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAAlUlEQVR42i3MsQrCMBSF4Ts46qa4iiDFVUVQiuIighmcRFAsiptDs/VZ+kjJ6yQP0P9AL3wkJ7kcS6E2LFPwFec8B7/Bm3wyDRe5oMjR31P0N4zIe9MQSsITLT7YZZZocfwttPCjeoiGzzOu2PYtf9WPcWThhTUMpZqwUhBH5YCHR4r1hDzFwTQ8iLYrzODwZaEwM+sAMS58o18opp8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/components/pages/home/imgs/leftLight.png
/* harmony default export */ var leftLight = ({"src":"/_next/static/media/leftLight.4052b537.png","height":570,"width":733,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAIAAABxZ0isAAAAmUlEQVR42hXJTQvBcADA4V8KjT8zb3vRmi0SU7RlhYOcuGziYDfKZRyU+BJOzg5y8kG1em4PtUYbqoCstEQ5JRW1gtAB1Zuvz9c7NEyzoyhGXlLTGHszfxnHxweoYZwcTglQb1r03MBwQz+6PV8f2d6Pgg2ZrpBNssLyJqvF7vL+/vqDbTCNwC0rDgVhgAY2yOSG4JQqtlTU/xtAFaG3BSLSAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/components/pages/home/imgs/rightLight.png
/* harmony default export */ var rightLight = ({"src":"/_next/static/media/rightLight.b07ecbbf.png","height":519,"width":560,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAAx0lEQVR42h3JUUvCUACG4Q9i5dxOZ2fLaMdlSWplFhQFsywDCxxRXUT1H7oLuuyvH17B5/ZRnJSk2x7JIUXYfEhsBrRNn3bqg1JTrnM8qVk2n0hn7PgbOv6CVloFJcazEQ/Z78+5vH5nq3xG5QLphHz3KChOe2SdKzazOXJLVLzx8vHD798/koKMPUAa0cofcN0GVa+cT794ar6RiiDJcXu3wPdqIjvF7t2jrEYakBWHQZJlNnvEV6dEyTFJNsG4MTYfESfdsAISZUr7GJG9XAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./src/components/common/DownloadPage/index.js + 7 modules
var DownloadPage = __webpack_require__(1066);
// EXTERNAL MODULE: ./src/components/pages/center/imgs/SideBarIcon.js
var SideBarIcon = __webpack_require__(89290);
// EXTERNAL MODULE: ./styles/pages/home.module.scss
var home_module = __webpack_require__(56004);
var home_module_default = /*#__PURE__*/__webpack_require__.n(home_module);
;// CONCATENATED MODULE: ./pages/index.js
/* eslint-disable react/no-danger */ 






















function Home() {
    var closeFunc = function closeFunc() {
        setVisible(false);
    };
    var handleRedirect = function handleRedirect() {
        if (false) {}
        if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
            return (0,sessionPass/* default */.ZP)("/login");
        }
        var _query = router.query, f = _query.f, ru = _query.ru;
        if (f && ru) {
            var paramsString = "";
            if (ru) {
                paramsString += "ru=".concat(ru, "&");
            }
            if (f) {
                paramsString += "f=".concat(f, "&");
            }
            if (paramsString.endsWith("&")) {
                paramsString = paramsString.slice(0, -1);
            }
            return (0,sessionPass/* default */.ZP)("".concat(window.location.protocol, "//m.").concat(window.location.hostname.split(".").slice(-2).join(".")).concat(i18n.language === "en" ? "/eng" : "/zh", "/login/login").concat(paramsString));
        }
        return (0,sessionPass/* default */.ZP)("".concat(phrase, "/login/login").concat((0,common/* referralRUF */.$)()));
    };
    var handleRedirect3 = function handleRedirect3() {
        closeFunc();
        router.push("download");
    };
    var ref = (0,react.useState)(0), popularTab = ref[0], setPopularTab = ref[1];
    var ref1 = (0,react.useState)(true), visible = ref1[0], setVisible = ref1[1];
    var ref2 = (0,esm/* useTranslation */.$G)("pages", {
        keyPrefix: "home"
    }), t = ref2.t, i18n = ref2.i18n;
    var user = (0,store/* useStore */.oR)().auth.user;
    var router = (0,next_router.useRouter)();
    var phrase = (0,useH5StringBuilder/* default */.Z)().phrase;
    var intervalFunction = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if ((0,common/* getPlatform */.Xf)() !== "pad" && (0,common/* getPlatform */.Xf)() !== "pc") {
            (0,common/* closeZendesk */.V1)();
            setTimeout(function() {
                clearInterval(intervalFunction.current);
            }, 80000);
            intervalFunction.current = setInterval(function() {
                (0,common/* closeZendesk */.V1)();
            }, 1000);
        }
        return function() {
            clearInterval(intervalFunction.current);
            (0,common/* openZendesk */.xh)(true);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (home_module_default()).page,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (home_module_default()).pageBackground,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        priority: true,
                        alt: "pageBackground",
                        src: bgColor,
                        layout: "responsive",
                        objectFit: "cover"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (home_module_default()).pageContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (home_module_default()).banner,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (home_module_default()).bannerContent,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (home_module_default()).h1,
                                            dangerouslySetInnerHTML: {
                                                __html: t("banner.intro.1st")
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (home_module_default()).h2,
                                            dangerouslySetInnerHTML: {
                                                __html: t("banner.intro.2nd")
                                            }
                                        }),
                                        !user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (home_module_default()).loadingButton,
                                            onKeyDown: handleRedirect,
                                            onClick: handleRedirect,
                                            "data-path": "/",
                                            role: "presentation",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: t("banner.getStart")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (home_module_default()).arrow,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBarIcon/* default */.Z, {
                                                        icon: "arrowRight"
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (home_module_default()).loadingButton2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (home_module_default()).bannerImage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        alt: "banner",
                                        src: bg/* default */.Z,
                                        objectFit: "contain",
                                        priority: true
                                    })
                                }),
                                visible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (home_module_default()).smallDownloadPanel,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (home_module_default()).smallDownload,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (home_module_default()).content,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (home_module_default()).contentLeft,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bitop/* default */.Z, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (home_module_default()).contentUpDown,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (home_module_default()).contentUp,
                                                                children: t("banner.smallDownload.appName")
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (home_module_default()).contentRight,
                                                    onKeyDown: handleRedirect3,
                                                    onClick: handleRedirect3,
                                                    role: "presentation",
                                                    children: t("banner.smallDownload.download")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    onKeyDown: closeFunc,
                                                    onClick: closeFunc,
                                                    role: "presentation",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "20",
                                                        height: "24",
                                                        viewBox: "0 -2 20 20",
                                                        fill: "none",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M15.1597 13.5145L11.6453 10L15.1597 6.48551C15.6134 6.03184 15.6134 5.29393 15.1597 4.84026C14.7061 4.38658 13.9682 4.38658 13.5145 4.84026L10 8.35474L6.48551 4.84026C6.03184 4.38658 5.29393 4.38658 4.84026 4.84026C4.38658 5.29393 4.38658 6.03184 4.84026 6.48551L8.35474 10L4.84026 13.5145C4.38658 13.9682 4.38658 14.7061 4.84026 15.1597C5.29393 15.6134 6.03184 15.6134 6.48551 15.1597L10 11.6453L13.5145 15.1597C13.9682 15.6134 14.7061 15.6134 15.1597 15.1597C15.6134 14.7061 15.6134 13.9682 15.1597 13.5145Z",
                                                            fill: "#D9D9D9"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (home_module_default()).quoteWheel,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(home/* BasicInfo */.Kz, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (home_module_default()).popularInfo,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (home_module_default()).popularInfotitle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (home_module_default()).h1,
                                        dangerouslySetInnerHTML: {
                                            __html: t("popularInfo.title")
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (home_module_default()).popularTabTitle,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: popularTab === 0 ? (home_module_default()).selected : "",
                                            onClick: function() {
                                                return setPopularTab(0);
                                            },
                                            onKeyDown: function(e) {
                                                if (e.key === "Enter" || e.key === "Space") {
                                                    setPopularTab(0);
                                                }
                                            },
                                            role: "button",
                                            tabIndex: 0,
                                            children: t("popularInfo.subTitle1")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: popularTab === 1 ? (home_module_default()).selected : "",
                                            onClick: function() {
                                                return setPopularTab(1);
                                            },
                                            onKeyDown: function(e) {
                                                if (e.key === "Enter" || e.key === "Space") {
                                                    setPopularTab(1);
                                                }
                                            },
                                            role: "button",
                                            tabIndex: 0,
                                            children: t("popularInfo.subTitle2")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: popularTab === 2 ? (home_module_default()).selected : "",
                                            onClick: function() {
                                                return setPopularTab(2);
                                            },
                                            onKeyDown: function(e) {
                                                if (e.key === "Enter" || e.key === "Space") {
                                                    setPopularTab(2);
                                                }
                                            },
                                            role: "button",
                                            tabIndex: 0,
                                            children: t("popularInfo.subTitle3")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (home_module_default()).popularSpot,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(home/* QuoteMarquee */.sc, {
                                        popularTab: popularTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (home_module_default()).market,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(home/* NewsBanner */.Ct, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (home_module_default()).tradingInfo,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (home_module_default()).tradingInfotitle,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (home_module_default()).h1,
                                            dangerouslySetInnerHTML: {
                                                __html: t("tradingInfo.title")
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            dangerouslySetInnerHTML: {
                                                __html: t("tradingInfo.des")
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (home_module_default()).tradingInfoData,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (home_module_default()).data,
                                                            children: "3000+"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (home_module_default()).label,
                                                            children: t("tradingInfo.infoLabel.eliteTraders")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (home_module_default()).data,
                                                            children: "1.5M"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (home_module_default()).label,
                                                            children: t("tradingInfo.infoLabel.copyRelationship")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (home_module_default()).data,
                                                            children: "100k+"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (home_module_default()).label,
                                                            children: t("tradingInfo.infoLabel.dailyOrders")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        !user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (home_module_default()).loadingButton,
                                            onKeyDown: handleRedirect,
                                            onClick: handleRedirect,
                                            "data-path": "/",
                                            role: "presentation",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: t("banner.getStart")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (home_module_default()).arrow,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBarIcon/* default */.Z, {
                                                        icon: "arrowRight"
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (home_module_default()).loadingButton2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (home_module_default()).tradingInfoImage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        alt: "tradingInfoImage",
                                        src: tradingInfoImage,
                                        objectFit: "contain"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (home_module_default()).trustInfo,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (home_module_default()).trustInfotitle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (home_module_default()).h1,
                                        dangerouslySetInnerHTML: {
                                            __html: t("trustInfo.title")
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (home_module_default()).trustInfoContent,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (home_module_default()).security,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (home_module_default()).securityImage,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        alt: "Security",
                                                        src: security,
                                                        objectFit: "contain",
                                                        priority: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (home_module_default()).securityText,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: t("trustInfo.benefit1")
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: t("trustInfo.des1")
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (home_module_default()).protection,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (home_module_default()).protectionImage,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        alt: "Protection",
                                                        src: protection,
                                                        objectFit: "contain",
                                                        priority: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (home_module_default()).protectionText,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: t("trustInfo.benefit2")
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: t("trustInfo.des2")
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (home_module_default()).downloadCon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadPage/* DownloadPage */.X, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (home_module_default()).startEarning,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (home_module_default()).startEarningLeftIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        alt: "StartEarningLeft",
                                        src: leftLight,
                                        objectFit: "cover"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (home_module_default()).startEarningtitle,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (home_module_default()).h1,
                                            dangerouslySetInnerHTML: {
                                                __html: t("startEarning.title")
                                            }
                                        }),
                                        !user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (home_module_default()).loadingButton,
                                            onKeyDown: handleRedirect,
                                            onClick: handleRedirect,
                                            "data-path": "/",
                                            role: "presentation",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: t("banner.getStart")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (home_module_default()).arrow,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBarIcon/* default */.Z, {
                                                        icon: "arrowRight"
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (home_module_default()).loadingButton2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (home_module_default()).startEarningRightIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        alt: "StartEarningRight",
                                        src: rightLight,
                                        objectFit: "cover"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var __N_SSG = true;
/* harmony default export */ var pages = ((0,mobxreact_esm/* observer */.Pi)(Home));


/***/ }),

/***/ 56004:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"home_root_include_ru__MuJrN","footer":"home_footer__VplJ5","page":"home_page__93UoA","pageBackground":"home_pageBackground__OctRX","pageContent":"home_pageContent__asU6n","banner":"home_banner__H9Iic","bannerContent":"home_bannerContent__cnBC9","h1":"home_h1__WAnZ7","h2":"home_h2__XDVYA","loadingButton":"home_loadingButton__RnZCQ","arrow":"home_arrow__JvS0W","bannerImage":"home_bannerImage__gqnqp","cs":"home_cs__TrPqO","quoteWheel":"home_quoteWheel__6vqKZ","popularInfo":"home_popularInfo__fqJmh","popularInfotitle":"home_popularInfotitle__MosJ_","popularTabTitle":"home_popularTabTitle__zlBIV","selected":"home_selected__zel9m","popularSpot":"home_popularSpot__BIXk2","market":"home_market__utT8u","tradingInfo":"home_tradingInfo__CYKA_","tradingInfotitle":"home_tradingInfotitle__wcFF1","tradingInfoData":"home_tradingInfoData__8fl_1","data":"home_data__sm9fE","label":"home_label__2LU3P","tradingInfoImage":"home_tradingInfoImage__MggyC","trustInfo":"home_trustInfo__dJ4K6","trustInfotitle":"home_trustInfotitle__hQz7J","security":"home_security__uaKZN","protection":"home_protection__Oi6Fd","securityText":"home_securityText__jebxC","protectionText":"home_protectionText__VtmTv","securityImage":"home_securityImage__6rpvT","protectionImage":"home_protectionImage__S5DpG","trustInfoContent":"home_trustInfoContent__j2UOy","downloadCon":"home_downloadCon__W_VJf","startEarning":"home_startEarning__27xT9","startEarningLeftIcon":"home_startEarningLeftIcon__37tgE","startEarningRightIcon":"home_startEarningRightIcon__3nxoG","startEarningtitle":"home_startEarningtitle__5mzCC","loadingButton2":"home_loadingButton2__48Rtx","smallDownloadPanel":"home_smallDownloadPanel__IAr7r","moveUp":"home_moveUp__n9EBt","smallDownload":"home_smallDownload__HxPNr","cross":"home_cross__SGneL","content":"home_content__wfuro","contentLeft":"home_contentLeft__5G9_q","contentUpDown":"home_contentUpDown__9VrLK","contentUp":"home_contentUp__mUjMV","contentRight":"home_contentRight__kYxLN"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3123,4467,9496,1842,9290,1650,1066,1416,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);